import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Typography, useTheme } from '@bluedolphin/ui';

type LayoutProps = {
    children: ReactNode;
};

/**
 * Layout component
 *
 * @returns {JSX.Element}
 */
export default function LayoutComponent({ children }: LayoutProps) {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <div className="layout__wrapper">
            <div className="backdrop-container">
                <div className="layout__children">{children}</div>
                <footer className="layout__footer">
                    <div className="layout__footer__left">
                        <Link
                            href="mailto:support@valueblue.nl"
                            target="_blank"
                            underline="hover"
                        >
                            <Typography
                                variant="body1"
                                sx={{
                                    color: theme.palette.primary.main,
                                    display: 'inline',
                                }}
                            >
                                {t('links.help')}
                            </Typography>
                        </Link>
                        <Link
                            href={t('links.cookiePrivacyStatementURL')}
                            target="_blank"
                            underline="hover"
                        >
                            <Typography
                                variant="body1"
                                sx={{
                                    color: theme.palette.primary.main,
                                    display: 'inline',
                                }}
                            >
                                {t('links.cookiePrivacyStatement')}
                            </Typography>
                        </Link>
                    </div>
                    <div className="layout__footer__right">
                        <Link
                            href={t('links.vbAcademyURL')}
                            target="_blank"
                            underline="hover"
                        >
                            <Typography
                                variant="body1"
                                sx={{
                                    color: theme.palette.primary.main,
                                    display: 'inline',
                                }}
                            >
                                {t('links.vbAcademy')}
                            </Typography>
                        </Link>
                        <Link
                            href={t('links.communityURL')}
                            target="_blank"
                            underline="hover"
                        >
                            <Typography
                                variant="body1"
                                sx={{
                                    color: theme.palette.primary.main,
                                    display: 'inline',
                                }}
                            >
                                {t('links.community')}
                            </Typography>
                        </Link>
                        <Link
                            href={t('links.webinarsURL')}
                            target="_blank"
                            underline="hover"
                        >
                            <Typography
                                variant="body1"
                                sx={{
                                    color: theme.palette.primary.main,
                                    display: 'inline',
                                }}
                            >
                                {t('links.webinars')}
                            </Typography>
                        </Link>
                    </div>
                </footer>
            </div>
        </div>
    );
}

/**
 * HOC wrapper for Layout pages
 *
 * @param Component
 *
 * @returns {Object}
 */
export function withLayoutHOC(Component) {
    return function WrappedComponent() {
        return (
            <LayoutComponent>
                <Component />
            </LayoutComponent>
        );
    };
}
